import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_CONFIG } from '../../../utils/apiConfig';
import './TodayOrders.css';

const TodayOrders = () => {
  const [totalOrders, setTotalOrders] = useState(0);
  const [orderDetails, setOrderDetails] = useState({
    cashBills: 0,
    creditBills: 0,
    products: 0
  });
  const [productNames, setProductNames] = useState([]);
  const [todayDate, setTodayDate] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTodayOrders = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        
        if (!token) {
          console.warn('No authentication token found');
          return;
        }

        // Set today's date
        const today = new Date();
        const formattedDate = today.toLocaleDateString('en-US', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
        setTodayDate(formattedDate);

        const headers = { Authorization: `Bearer ${token}` };
        
        // Fetch today's data from multiple endpoints
        const [cashResponse, creditResponse, productsResponse] = await Promise.all([
          axios.get(`${API_CONFIG.BASE_URL}/api/cashbills/today`, { headers }),
          axios.get(`${API_CONFIG.BASE_URL}/api/creditbills/today`, { headers }),
          axios.get(`${API_CONFIG.BASE_URL}/api/products`, { headers })
        ]);

        // Extract data with fallbacks
        const cashBillsData = cashResponse.data?.bills || [];
        const creditBillsData = creditResponse.data?.bills || [];
        const products = productsResponse.data?.length || 0;

        const cashBills = cashBillsData.length;
        const creditBills = creditBillsData.length;

        // Extract product names from cash bills and credit bills
        const allProductNames = [];
        
        // Extract from cash bills
        cashBillsData.forEach(bill => {
          if (bill.items && Array.isArray(bill.items)) {
            bill.items.forEach(item => {
              if (item.itemname || item.description) {
                allProductNames.push(item.itemname || item.description);
              }
            });
          }
        });

        // Extract from credit bills
        creditBillsData.forEach(bill => {
          if (bill.items && Array.isArray(bill.items)) {
            bill.items.forEach(item => {
              if (item.itemname || item.description) {
                allProductNames.push(item.itemname || item.description);
              }
            });
          }
        });

        // Remove duplicates and limit to first 10 products
        const uniqueProductNames = [...new Set(allProductNames)].slice(0, 10);

        // Calculate total orders (cash bills + credit bills)
        const total = cashBills + creditBills;

        setOrderDetails({
          cashBills,
          creditBills,
          products
        });
        setTotalOrders(total);
        setProductNames(uniqueProductNames);
      } catch (error) {
        console.error('Error fetching today orders:', error);
        setTotalOrders(0);
        setOrderDetails({
          cashBills: 0,
          creditBills: 0,
          products: 0
        });
        setProductNames([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTodayOrders();
  }, []);

  return (
    <div className="orders-card orders-animated">
      <h4>Today's Orders</h4>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="orders-details">
          <div className="today-date">
            <p className="date-text">{todayDate}</p>
          </div>
          <p className="total-orders">{totalOrders}</p>
          <div className="order-breakdown">
            <span className="breakdown-item">Cash: {orderDetails.cashBills}</span>
            <span className="breakdown-item">Credit: {orderDetails.creditBills}</span>
            <span className="breakdown-item">Products: {orderDetails.products}</span>
          </div>
          <div className="product-names">
            <p className="product-names-title">Today's Products:</p>
              <div className="products-container">
              {productNames.length > 0 ? (
                productNames.map((product, index) => (
                  <span key={index} className="product-item">
                    {product}
                  </span>
                ))
              ) : (
                <span className="no-products-message">
                  No products sold today
                </span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TodayOrders;